import { render, staticRenderFns } from "./thesisModal.vue?vue&type=template&id=582dff08&scoped=true&"
import script from "./thesisModal.vue?vue&type=script&lang=js&"
export * from "./thesisModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582dff08",
  null
  
)

export default component.exports